import BaseAPI from "../api";

const path: string = "examination";

export class ExaminationApi extends BaseAPI {
  static createExamination(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static getExaminationById(id: any): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }

  static updateExamination(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteExamination(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static getExaminationList(query?: any): Promise<any> {
    return this.api.get(`${path}/list`, {
      params: { ...query },
    });
  }
}